import React from 'react';
import { withTheme, constants } from '@match/react-component-library';
import styled from 'react-emotion';

const { SEMANTIC_COLOR_NAME } = constants;

interface SvgProps {
  color: string;
}

const StyledSvg = styled('svg')(({ color }: SvgProps) => ({
  fill: color
})
);

export interface LogoProps {
  alignX?: 'left' | 'center';
  light?: boolean;
  dark?: boolean;
  color?: constants.SemanticColorName;
  height?: number | string;
  size?: 'default' | 'abbreviated';
  width?: number | string;
  theme?: any;
}

class Logo extends React.PureComponent<LogoProps> {
  static defaultProps: LogoProps = {
    alignX: 'left',
    light: false,
    dark: false,
    color: constants.SEMANTIC_COLOR_NAME.PRIMARY1,
    height: '100%',
    size: 'default',
    width: '100%',
  };

  render() {
    const {
      light,
      dark,
      color,
      width,
      height,
      alignX,
      size,
      theme
    } = this.props;

    const themeName = theme.branding.name;
    const logoSprite = (typeof theme.components.logo.url === 'function')
      ? theme.components.logo.url()
      : theme.components.logo.url;

    let fillColor;
    if (light) {
      fillColor = theme.components.logo.light || theme.palette[SEMANTIC_COLOR_NAME.LIGHT];
    } else if (dark) {
      fillColor = theme.components.logo.dark || theme.palette[SEMANTIC_COLOR_NAME.PRIMARY1];
    } else {
      fillColor = theme.palette[color as constants.SemanticColorName];
    }

    return (
      <StyledSvg color={fillColor} height={height} width={width}>
        <use xlinkHref={`${logoSprite}#${themeName}-${size}-${alignX}`} />
      </StyledSvg>
    );
  }
}

export default withTheme(Logo);
